import { useSearchParams } from "react-router-dom";
import { VehicleSearchContainer } from "./vehicleSearch.container";

export const VehicleSearchRoute = () => {
  const [searchParams] = useSearchParams();
  const key = searchParams.get("key") ?? "";

  return <VehicleSearchContainer key={key} searchKey={key} />;
};
